import { Controller } from "@hotwired/stimulus"
import type { ActionEvent, TurboMorphAttributeEvent } from "@/v2/types"

type Tab = HTMLLinkElement | HTMLButtonElement

export default class extends Controller<HTMLElement> {
  static targets = ["tab", "content"]

  declare readonly tabTargets: Tab[]
  declare readonly contentTargets: HTMLElement[]

  connect(): void {
    this.showTab()

    addEventListener("turbo:before-morph-attribute", (e) => {
      this.preserveTabName(e)
    })

    addEventListener("turbo:morph", () => {
      this.showTab()
    })
  }

  preserveTabName(e: TurboMorphAttributeEvent): void {
    if (
      e.target === this.element &&
      e.detail.attributeName === "data-named-tabs-tab-name"
    ) {
      e.preventDefault()
    }
  }

  change(e: ActionEvent<{ tabName: string }>): void {
    this.tabName = e.params.tabName
  }

  showTab(): void {
    for (const tabTarget of this.tabTargets) {
      tabTarget.classList.toggle("active", tabTarget.dataset.name === this.tabName)
    }

    for (const contentTarget of this.contentTargets) {
      const tabNames = (contentTarget.dataset.tabName ?? "").split("|")
      contentTarget.classList.toggle("hidden", !tabNames.includes(this.tabName))
    }
  }

  get tabName(): string {
    return this.data.get("tab-name") ?? ""
  }

  set tabName(name: string) {
    this.data.set("tab-name", name.toString())
    this.showTab()
  }
}
